module.exports = __webpack_public_path__ + "static/start-up-0de9d193f3dc08fb44042e535fb8074b.jpg";